import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-flexbox-grid/lib/index";

import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Collapse,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HelpIcon from "@material-ui/icons/HelpOutline";
import Search from "@material-ui/icons/Search";
import ShareIcon from "@material-ui/icons/Share";
import Refresh from "@material-ui/icons/Refresh";

import DatePickerWrapped from "components/DatePickerWrapped";

import SelectSearchable from "components/Select";

import { DATA_PROCESS_LEVELS } from "../constants";

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250
  },
  chip: {
    margin: theme.spacing(0.25)
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    }),
    marginLeft: "auto",
    [theme.breakpoints.up("sm")]: {
      marginRight: -8
    }
  },
  expandOpen: {
    transform: "rotate(180deg)"
  }
});

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 200,
      width: 250
    }
  }
};

class FilterCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      moreOptionsOpen: false,
      copyText: "Copy Query"
    };
  }

  setCopyText = text => {
    this.setState(state => ({ ...state, copyText: text }));
  };

  handleExpandClick = () => {
    this.setState(state => ({
      ...state,
      moreOptionsOpen: !state.moreOptionsOpen
    }));
  };

  handleCopyButtonClick = () => {
    navigator.clipboard.writeText(window.location.href);
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Card style={{ overflow: "visible" }}>
          <CardHeader
            title="Search"
            action={
              <Button
                style={{ marginBottom: "10px" }}
                variant="text"
                onClick={() => this.props.onFAQClick()}
              >
                FAQ <HelpIcon style={{ marginLeft: "3px" }} />
              </Button>
            }
          />
          <CardContent>
            <Row bottom="xs">
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <DatePickerWrapped
                  floatingLabelText="Date from"
                  maxDate={this.props.endDateFilter}
                  value={this.props.startDateFilter}
                  onChange={this.props.onStartDateFilterChange}
                />
              </Col>
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <DatePickerWrapped
                  floatingLabelText="Date to"
                  minDate={this.props.startDateFilter}
                  value={this.props.endDateFilter}
                  onChange={this.props.onEndDateFilterChange}
                />
              </Col>
            </Row>
            <Row bottom="xs" style={{ marginTop: "10px" }}>
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <SelectSearchable
                  isMulti
                  isLoading={this.props.surveyStationOptionsIsFetching}
                  onChange={this.props.onWorkareaFilterChipChange}
                  placeholder="Select workarea(s)"
                  options={this.props.workareaOptions}
                  value={this.props.workareaFilter}
                  label="Work Area"
                />
              </Col>
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <span className={styles.root}>
                  <SelectSearchable
                    isMulti
                    isLoading={this.props.surveyStationOptionsIsFetching}
                    onChange={this.props.onSurveyFilterChipChange}
                    placeholder="Select survey(s)"
                    options={this.props.surveyOptions}
                    value={this.props.surveyFilter}
                    label="Survey"
                  />
                </span>
              </Col>
            </Row>
            <Row bottom="xs">
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <span className={styles.root}>
                  <SelectSearchable
                    isMulti
                    isLoading={this.props.surveyStationOptionsIsFetching}
                    onChange={this.props.onStationFilterChipChange}
                    placeholder="Select station(s)"
                    options={this.props.stationOptions}
                    value={this.props.stationFilter}
                    label="Station"
                  />
                </span>
              </Col>
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <SelectSearchable
                  isGrouped
                  label="Download type"
                  value={`${this.props.downloadType}/${this.props.processingStageFilter}`}
                  options={[
                    {
                      label: "Original files (r_text/.hex/.cnv)",
                      options: [
                        { value: "hexrsk/raw", label: "Raw hex/rsk files" },
                        {
                          value: "file/1_datCnv",
                          label: "Annotated text files"
                        },
                        {
                          value: "file/8_binAvg",
                          label: "Processed files (SB only)"
                        }
                      ]
                    },
                    {
                      label: "Spreadsheets",
                      options: [
                        {
                          value: "csv/1_datCnv",
                          label: "Unprocessed data (.csv)"
                        },
                        {
                          value: "xlsx/1_datCnv",
                          label: "Unprocessed data (.xlsx)"
                        },
                        {
                          value: "csv/8_binAvg",
                          label: "Processed data (.csv)"
                        },
                        {
                          value: "xlsx/8_binAvg",
                          label: "Processed data (.xlsx)"
                        },
                        {
                          value: "csv/9_qc_auto",
                          label: "Auto QC'd data (.csv)"
                        },
                        {
                          value: "xlsx/9_qc_auto",
                          label: "Auto QC'd data (.xlsx)"
                        },
                        {
                          value: "csv/10_qc_pi",
                          label: "Manual QC'd data (.csv)"
                        },
                        {
                          value: "xlsx/10_qc_pi",
                          label: "Manual QC'd data (.xlsx)"
                        },
                        {
                          value: "csv/11_qc_pi_research",
                          label: "Research Ready data, bad data removed (.csv)"
                        },
                        {
                          value: "xlsx/11_qc_pi_research",
                          label: "Research Ready data, bad data removed (.xlsx)"
                        }
                      ]
                    }
                  ]}
                  onChange={this.props.onDownloadTypeSelect}
                />
              </Col>
            </Row>
          </CardContent>
        </Card>
        <Card>
          <CardHeader
            title="More Options"
            action={
              <IconButton
                className={classnames(classes.expand, {
                  [classes.expandOpen]: this.state.moreOptionsOpen
                })}
                onClick={this.handleExpandClick}
                aria-expanded={this.state.expanded}
                aria-label="Show more"
                style={{ marginTop: -9 }}
              >
                <ExpandMoreIcon />
              </IconButton>
            }
          />
          <Collapse
            in={this.state.moreOptionsOpen}
            timeout="auto"
            unmountOnExit
          >
            <CardContent>
              <Row bottom="xs">
                <Col xs={12} md={6} lg={4} lgOffset={1}>
                  <SelectSearchable
                    isMulti
                    useCreatable
                    fullWidth
                    label="Limit to filenames"
                    value={this.props.filenameFilter}
                    options={[]}
                    onChange={this.props.onFilenameFilterChipChange}
                  />
                </Col>
                <Col xs={12} md={6} lg={4} lgOffset={1}>
                  <FormControl fullWidth style={{ marginBottom: 15 }}>
                    <InputLabel>Instrument type</InputLabel>
                    <Select
                      value={this.props.instrumentFilter}
                      onChange={this.props.onInstrumentFilterChange}
                    >
                      <MenuItem value="any">Any</MenuItem>
                      {this.props.deviceModels.map(model => {
                        return (
                          <MenuItem key={model} value={model}>
                            {model}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Col>
                <Col xs={12} md={6} lg={4} lgOffset={1}>
                  <SelectSearchable
                    isMulti
                    useCreatable
                    label="Limit to cast pks"
                    value={this.props.castPkFilter}
                    options={[]}
                    onChange={this.props.onCastPkFilterChipChange}
                  />
                </Col>

                <Col xs={12} md={6} lg={4} lgOffset={1}>
                  <FormControl fullWidth style={{ marginBottom: 15 }}>
                    <InputLabel>Instrument serial number</InputLabel>
                    <Select
                      value={this.props.serialNumFilter}
                      onChange={this.props.onSerialNumFilterChange}
                      MenuProps={MenuProps}
                    >
                      <MenuItem value="any">Any</MenuItem>
                      {this.props.deviceSn.map(number => {
                        return (
                          <MenuItem key={number} value={number}>
                            {number}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Col>
                <Col xs={12} md={6} lg={4} lgOffset={1}>
                  <SelectSearchable
                    isMulti
                    useCreatable
                    label="Limit to Hakai IDs"
                    value={this.props.hakaiIdFilter}
                    options={[]}
                    onChange={this.props.onHakaiIdFilterChipChange}
                  />
                </Col>
                <Col xs={12} md={6} lg={4} lgOffset={1}>
                  <SelectSearchable
                    isMulti
                    onChange={this.props.onOrganizationFilterChange}
                    label="Limit to Organization"
                    placeholder="Select organization(s)"
                    value={this.props.organizationFilter}
                    options={this.props.organizationOptions}
                  />
                </Col>
                <Col xs={12} md={6} lg={4} lgOffset={1}>
                  <FormControlLabel
                    style={{ marginBottom: 15 }}
                    disabled={this.props.processingStageFilter !== "1_datCnv"}
                    control={
                      <Switch
                        checked={this.props.bufferFilter}
                        onChange={() =>
                          this.props.onBufferFilterChange(
                            !this.props.bufferFilter
                          )
                        }
                        value="bufferfilter"
                      />
                    }
                    label="Add extended buffer to raw RBR data"
                  />
                </Col>
                <Col xs={12} md={6} lg={4} lgOffset={1} />
                <Col xs={12} md={6} lg={4} lgOffset={1}>
                  <FormControlLabel
                    style={{ marginTop: -20 }}
                    disabled={
                      !DATA_PROCESS_LEVELS.includes(
                        this.props.processingStageFilter
                      )
                    }
                    control={
                      <Switch
                        checked={this.props.upcastFilter}
                        onChange={() =>
                          this.props.onUpcastFilterChange(
                            !this.props.upcastFilter
                          )
                        }
                        value="upcastfilter"
                      />
                    }
                    label="Include upcast for processed RBR data"
                  />
                </Col>
                <Col xs={12} md={6} lg={4} />
              </Row>
            </CardContent>
          </Collapse>
          <CardContent>
            <Row bottom="xs">
              <Col xs={12} md={6} lg={5} lgOffset={1}>
                <Row>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={this.props.onFindCastsClick}
                    style={{
                      marginTop: "15px",
                      marginBottom: "15px",
                      color: "#fff"
                    }}
                  >
                    Search
                    <Search />
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      this.handleCopyButtonClick();
                      this.setCopyText("Copied URL");
                    }}
                    style={{
                      marginTop: "15px",
                      marginBottom: "15px",
                      marginLeft: "15px",
                      color: "#fff"
                    }}
                  >
                    {this.state.copyText}
                    <ShareIcon />
                  </Button>
                  <Button
                    style={{ marginLeft: "10px" }}
                    default
                    onClick={this.props.onResetButtonClick}
                  >
                    Reset
                    <Refresh />
                  </Button>
                </Row>
              </Col>
              <Col xs={12} md={6} lg={5} lgOffset={1}>
                <FormControl fullWidth>
                  <InputLabel>Casts to display per page</InputLabel>
                  <Select
                    value={this.props.itemsPerPage}
                    onChange={this.props.onItemsPerPageChange}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                  </Select>
                </FormControl>
              </Col>
            </Row>
          </CardContent>
        </Card>
      </div>
    );
  }
}

FilterCard.propTypes = {
  classes: PropTypes.shape({
    actions: PropTypes.string,
    chip: PropTypes.string,
    expand: PropTypes.string,
    expandOpen: PropTypes.string,
    root: PropTypes.string
  }).isRequired,
  surveyOptions: PropTypes.arrayOf(PropTypes.string),
  surveyFilter: PropTypes.arrayOf(PropTypes.string),
  stationOptions: PropTypes.arrayOf(PropTypes.string),
  stationFilter: PropTypes.arrayOf(PropTypes.string),
  startDateFilter: PropTypes.string,
  endDateFilter: PropTypes.string,
  downloadType: PropTypes.string,
  processingStageFilter: PropTypes.string,
  instrumentFilter: PropTypes.string,
  serialNumFilter: PropTypes.string,
  workareaFilter: PropTypes.arrayOf(PropTypes.string),
  workareaOptions: PropTypes.arrayOf(PropTypes.string),
  organizationFilter: PropTypes.arrayOf(PropTypes.string),
  organizationOptions: PropTypes.arrayOf(PropTypes.string),
  bufferFilter: PropTypes.bool,
  upcastFilter: PropTypes.bool,
  surveyStationOptionsIsFetching: PropTypes.bool.isRequired,
  filenameFilter: PropTypes.arrayOf(PropTypes.string),
  castPkFilter: PropTypes.arrayOf(PropTypes.string),
  hakaiIdFilter: PropTypes.arrayOf(PropTypes.string),
  itemsPerPage: PropTypes.number,
  onFAQClick: PropTypes.func.isRequired,
  onStartDateFilterChange: PropTypes.func.isRequired,
  onEndDateFilterChange: PropTypes.func.isRequired,
  onSurveyFilterChipChange: PropTypes.func.isRequired,
  onStationFilterChipChange: PropTypes.func.isRequired,
  onDownloadTypeSelect: PropTypes.func.isRequired,
  onInstrumentFilterChange: PropTypes.func.isRequired,
  onSerialNumFilterChange: PropTypes.func.isRequired,
  onWorkareaFilterChipChange: PropTypes.func.isRequired,
  onOrganizationFilterChange: PropTypes.func.isRequired,
  onBufferFilterChange: PropTypes.func.isRequired,
  onUpcastFilterChange: PropTypes.func.isRequired,
  onFilenameFilterChipChange: PropTypes.func.isRequired,
  onCastPkFilterChipChange: PropTypes.func.isRequired,
  onHakaiIdFilterChipChange: PropTypes.func.isRequired,
  onItemsPerPageChange: PropTypes.func.isRequired,
  onFindCastsClick: PropTypes.func.isRequired,
  onResetButtonClick: PropTypes.func.isRequired,
  deviceModels: PropTypes.arrayOf(PropTypes.string),
  deviceSn: PropTypes.arrayOf(PropTypes.string)
};

FilterCard.defaultProps = {
  surveyOptions: [],
  surveyFilter: [],
  stationOptions: [],
  stationFilter: [],
  startDateFilter: undefined,
  endDateFilter: undefined,
  downloadType: "xlsx",
  processingStageFilter: "8_binAvg",
  instrumentFilter: "any",
  serialNumFilter: "any",
  workareaFilter: [],
  workareaOptions: [],
  organizationFilter: [],
  organizationOptions: [],
  bufferFilter: false,
  upcastFilter: false,
  filenameFilter: [],
  castPkFilter: [],
  hakaiIdFilter: [],
  itemsPerPage: 10,
  deviceModels: {},
  deviceSn: {}
};

export default withStyles(styles)(FilterCard);
